import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { refreshCachedDevice } from '@/api/devices';
import { PostUpdateWaveHeightAlertPayload, PostUpdateWaveHeightAlertResponse } from '@/api/waveHeight/types';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';

export const postUpdateWaveHeightAlert = (
    payload: PostUpdateWaveHeightAlertPayload
): Promise<PostUpdateWaveHeightAlertResponse> => {
    return axios.post('/device/update-waveheightalert', payload);
};

type UsePostUpdateWaveHeightAlertOptions = {
    config?: MutationConfig<typeof postUpdateWaveHeightAlert>;
    data?: PostUpdateWaveHeightAlertPayload;
};

export const usePostUpdateWaveHeightAlert = ({ config }: UsePostUpdateWaveHeightAlertOptions = {}) => {
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: postUpdateWaveHeightAlert,
        onSuccess: (_data, variables) => {
            refreshCachedDevice(variables.spotterId);
            mixpanel?.track('Wave height alert updated', {
                spotterId: variables.spotterId,
                height: `${variables.height} meters`,
            });
        },
    });
};
